import { getAuthenticatedFetch } from "../../msal/authenticatedFetchService";

class TerminationsService {
    async getTerminations() {
        let url = `${process.env.REACT_APP_SELF_SERVICE_CARECOMPLIANCE_API_URL}/Terminations/terminations`;
        let response = await getAuthenticatedFetch()(url);

        if (!response.ok) {
            throw new Error();
        }

        return response.json();
    }
}

export default new TerminationsService();
